import { Link } from "react-router-dom";
import { useAppConfig } from "@/lib/use-app-config";

// React Router 7 port of components/MarketingFooter.tsx. Replaces every
// `next/link` `<Link href>` with `react-router-dom` `<Link to>`. The
// `#download` anchor stays as a plain `<a>` so it scrolls on the current
// page instead of trying to RR-navigate to a hash route.

export function MarketingFooter() {
  const { companyName } = useAppConfig();

  return (
    <footer className="footer">
      <div className="shell">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="nav-brand">
              <span className="nav-brand-mark">
                <img src="/simple_icon.svg" alt="" width={36} height={24} />
              </span>
              Asistent Auto
            </Link>
            <p>
              Built în Cluj. Date în UE. Asistentul tău digital pentru
              tot ce înseamnă hârtii de mașină în România.
            </p>
          </div>
          <div>
            <h5>Produs</h5>
            <ul>
              <li><Link to="/functii">Funcții</Link></li>
              <li><Link to="/app">Aplicația web</Link></li>
              <li><a href="#download">Descarcă</a></li>
            </ul>
          </div>
          <div>
            <h5>Companie</h5>
            <ul>
              <li><Link to="/despre">Despre</Link></li>
              <li><Link to="/intrebari">Întrebări</Link></li>
            </ul>
          </div>
          <div>
            <h5>Legal</h5>
            <ul>
              <li><Link to="/termeni">Termeni</Link></li>
              <li><Link to="/confidentialitate">Confidențialitate</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 {companyName}</span>
          <span>v1.0 · aprilie 2026</span>
        </div>
      </div>
    </footer>
  );
}
